import { atom } from 'jotai';

export type ImageTypes =
  | 'dentalPhotos'
  | 'panoPhotos'
  | 'fmxPhotos'
  | 'otherPhotos'
  | 'fmxAsOther';

export const imageBrowserOpenAtom = atom<boolean>(false);
export const imageBrowserExpandedAtom = atom<boolean>(false);
export const enabledImageTypesAtom = atom<ImageTypes[]>([
  'dentalPhotos',
  'panoPhotos',
  'fmxPhotos',
  'otherPhotos',
  'fmxAsOther',
]);
export const showingAllAtom = atom<boolean>(false);
